import { AuthProviderProps } from 'oidc-react';
import { ENV } from 'src/config/env';

const SIGN_IN_PARAMS = ['code', 'state', 'session_state', 'iss'];

const isSignInParam = (part: string) => SIGN_IN_PARAMS.includes(decodeURIComponent(part.split('=')[0]));

/** Live-Runde 13 (Z-6): the static page Keycloak answers the silent SSO check to (public-all). */
export const SILENT_CHECK_PATH = '/silent-check-sso.html';

/** The address carries Keycloak's login answer — the OIDC callback the provider processes itself. */
export function hasSignInAnswer({ search, hash }: Pick<Location, 'search' | 'hash'>): boolean {
    return [search.slice(1), hash.slice(1)].some(part => part.split('&').some(isSignInParam));
}

/** Live-Runde 13: the address without the login answer — a copied or new-tab link never carries it. */
export function withoutSignInParams({
    pathname,
    search,
    hash,
}: Pick<Location, 'pathname' | 'search' | 'hash'>): string {
    const query = search
        .slice(1)
        .split('&')
        .filter(part => part !== '' && !isSignInParam(part))
        .join('&');
    // a fragment answer carries the parameters in the hash instead
    const keptHash = hasSignInAnswer({ search: '', hash }) ? '' : hash;
    return `${pathname}${query ? `?${query}` : ''}${keptHash}`;
}

export const OIDC_CONF: AuthProviderProps = {
    onSignIn: async () => {
        window.history.replaceState(window.history.state, '', withoutSignInParams(window.location));
        // the router reads the address only on popstate
        window.dispatchEvent(new PopStateEvent('popstate', { state: window.history.state }));
    },
    authority: ENV.oidcAuthority,
    clientId: 'lmnt-web',
    redirectUri: window.location.origin,
    silentRedirectUri: window.location.origin + SILENT_CHECK_PATH,
    postLogoutRedirectUri: window.location.origin,
    scope: 'openid profile email api jsf',
    autoSignIn: false,
    automaticSilentRenew: true,
    responseType: 'code',
    loadUserInfo: true,
};
